import type {
  AppNotificationTextProps,
  ParagraphEllipsis,
} from "./app-notification-text.type";

import { Typography } from "antd";

import "./app-notification-text.style.less";

const { Paragraph } = Typography;

const AppNotificationText = ({ children, rows }: AppNotificationTextProps) => {
  const ellipsis: ParagraphEllipsis =
    typeof rows === "number" ? { rows } : undefined;

  return (
    <Paragraph className="app-notification-text" ellipsis={ellipsis}>
      {children}
    </Paragraph>
  );
};

export default AppNotificationText;
